// @flow
import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'


class RenameColumn extends React.Component {
    constructor(props: PropsType) {
        super(props)
        this.state = {
            name: '',
            focus: true,
        }
    }

    handleNameChange = (e) => {
        this.setState({
            name: e.target.value,
        })
    }

    handleTypeChange = (e) => {
        this.setState({
            type: e.target.value,
        })
    }

    clearInput = () => {
        this.setState({
            type: '',
            name: '',
            focus: true,
        })
    }

    onAccept = () => {
        this.props.onAccept(this.state.name, this.state.type)
        this.clearInput()
    }

    onClose = () => {
        this.clearInput()
        this.props.onClose()
    }

    fixFocus = () => {
        // Using this roundabout way of doing things
        // because autoFocus wasn't working correctly.
        if(this.state.focus){
            const el = document.getElementById('rename-column-name')
            el.focus()
            this.setState({
                focus: false,
            })
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.onClose}
            >
                <DialogTitle>New Name for Column {this.props.name}</DialogTitle>
                <DialogContent>
                    <TextField
                        id="with-placeholder"
                        label="Column Name"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            id: 'rename-column-name',
                            autoFocus: true,
                            onBlur: this.fixFocus,
                        }}
                        style={{ marginBottom: '10px' }}
                        fullWidth
                        onChange={this.handleNameChange}
                        value={this.state.name}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => { this.onAccept(this.state.name) }}
                    >
                        Accept
                    </Button>
                    <Button
                        onClick={this.onClose}
                    >
                        Close
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }
}

export default RenameColumn
